import { RootState } from 'store';
import { getData } from 'services/api';
import { handleDownload } from 'utils/handleLink';
import { initialState } from 'store/slices/OrdersPageSlice';
import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { postToast } from 'features/common/utils/postFlash';

export const useOrdersPage = (routeEventId?: string) => {
	const { t } = useTranslation();
	const { selectedPeriod, selectedEvents } = useSelector((state: RootState) => state.ordersPage);

	const [searchText, setSearchText] = useState('');

	const url = new URL(window.location.href);
	const searchParams = new URLSearchParams(url.search);
	const queryEventId = searchParams.get('event_id');

	const eventFilterApplied = selectedEvents.applied['-1']
		? queryEventId
		: Object.keys(selectedEvents.applied).join(',');

	const isNotFiltered =
		selectedPeriod.applied === initialState.selectedPeriod.applied &&
		selectedEvents.applied === initialState.selectedEvents.applied;

	const downloadOrdersQuery = useMutation(async () => {
		try {
			const params = new URLSearchParams();
			params.set('per_page', '-1');
			params.set('date', selectedPeriod.applied);
			params.set('search', searchText);
			// On the per-event route the CSV must scope to that show, not the org-wide redux filter
			// (which defaults to the '-1' all-events sentinel). The route id wins when present.
			const downloadEventIds = routeEventId || eventFilterApplied;
			if (downloadEventIds) params.set('event_ids', downloadEventIds);
			const res = await getData('/orders/csv?' + params.toString());
			handleDownload(res, 'orders.csv');
		} catch {
			postToast('error', t('ordersPage-csv-error', 'Error downloading CSV'));
		}
	});

	return {
		downloadOrdersQuery,
		selectedPeriod,
		selectedEvents,
		searchText,
		setSearchText,
		eventFilterApplied,
		isNotFiltered,
	};
};
